import React, { useState } from 'react';
import { useData } from '../../data/DataProvider';
import { useToast } from '../../shared/components/ToastProvider';
import { portalApi } from '../../lib/api';

// AI assistant settings (pass 7 §7B). Keys are stored per-tenant and
// consumed ONLY by portal-api server-side — the browser never sees them.
// With no key configured every AI feature falls back to a deterministic
// template, so the platform keeps working without a provider.
export default function AiSettings() {
  const { data, updateCollection } = useData();
  const { notify } = useToast();
  const [form, setForm] = useState({ ...data.settings.ai });
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const save = async (event) => {
    event.preventDefault();
    try {
      await updateCollection('settings', { ...data.settings, ai: form });
      notify('AI settings saved');
    } catch (err) {
      notify(err.message || 'Failed to save AI settings', 'error');
    }
  };

  const runTest = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const result = await portalApi.aiTest();
      setTestResult(result);
    } catch (err) {
      setTestResult({ ok: false, message: err.message || 'Test failed' });
    } finally {
      setTesting(false);
    }
  };

  return (
    <section className="panel settings-form">
      <h3>AI assistant</h3>
      <p className="field-hint">Drafts replies to client messages and summarises client records. Works with any OpenAI-compatible API (OpenRouter by default). Keys live on the server — nothing AI-related ships to the browser.</p>

      <form onSubmit={save}>
        <label className="check-row">
          <input
            type="checkbox"
            checked={form.enabled}
            onChange={(event) => setForm({ ...form, enabled: event.target.checked })}
          />
          Enable AI features
        </label>

        <label>API key
          <input
            type="password"
            value={form.api_key || ''}
            placeholder="sk-or-…"
            autoComplete="off"
            onChange={(event) => setForm({ ...form, api_key: event.target.value })}
          />
        </label>
        <label>Model
          <input
            value={form.model || ''}
            placeholder="openai/gpt-4o-mini"
            onChange={(event) => setForm({ ...form, model: event.target.value })}
          />
        </label>
        <label>Base URL
          <input
            value={form.base_url || ''}
            placeholder="https://openrouter.ai/api/v1"
            onChange={(event) => setForm({ ...form, base_url: event.target.value })}
          />
        </label>

        <div className="header-actions">
          <button className="primary-button">Save AI settings</button>
          <button
            type="button"
            className="secondary-button"
            onClick={runTest}
            disabled={testing}
          >
            {testing ? 'Testing…' : 'Test connection'}
          </button>
        </div>
      </form>

      {testResult && (
        <p className={`field-hint ${testResult.ok ? 'test-ok' : 'test-fail'}`}>
          {testResult.ok ? '✓' : '✕'} {testResult.message}
          {testResult.model ? ` (${testResult.model})` : ''}
        </p>
      )}
    </section>
  );
}
